module.exports = __webpack_public_path__ + "img/3.37ff736c.png";